"use strict";
var $ = require("../internals/export");
var difference = require("../internals/set-difference");
var fails = require("../internals/fails");
var setMethodAcceptSetLike = require("../internals/set-method-accept-set-like");
var SET_LIKE_INCORRECT_BEHAVIOR = !setMethodAcceptSetLike("difference", function(result) {
  return result.size === 0;
});
var FORCED = SET_LIKE_INCORRECT_BEHAVIOR || fails(function() {
  var setLike = {
    size: 1,
    has: function() {
      return true;
    },
    keys: function() {
      var index = 0;
      return {
        next: function() {
          var done = index++ > 1;
          if (baseSet.has(1)) baseSet.clear();
          return { done, value: 2 };
        }
      };
    }
  };
  var baseSet = /* @__PURE__ */ new Set([1, 2, 3, 4]);
  return baseSet.difference(setLike).size !== 3;
});
$({ target: "Set", proto: true, real: true, forced: FORCED }, {
  difference
});
